__turbopack_context__.v({
  "active": "Navbar-module__dVeNwG__active",
  "navbar": "Navbar-module__dVeNwG__navbar",
});
